export default {"src":"https://static.finncdn.no/_c/travel/_next/static/media/empty-image.fd1f5653.svg","height":360,"width":480,"blurWidth":0,"blurHeight":0};